import { isSameDay } from 'date-fns'
import { HOUR_PX } from './weekGeometry'

/** Hours of the body in view at once (the rest is reached by scrolling). */
export const VISIBLE_HOURS = 12
export const DEFAULT_SCROLL_HOUR = 7
const HOURS_BEFORE_NOW = 1

/**
 * Where the body is scrolled when a week or day opens: an hour before the
 * current time if one of the visible days is today, otherwise 7am. Not capped
 * at the end: the header's height varies, so only the browser knows the real
 * scroll range, and it clamps `scrollTop` to it.
 */
export function initialScrollTop(days: Date[], now: Date): number {
  if (!days.some((day) => isSameDay(day, now))) {
    return DEFAULT_SCROLL_HOUR * HOUR_PX
  }
  const hour = now.getHours() + now.getMinutes() / 60
  return Math.max(Math.round((hour - HOURS_BEFORE_NOW) * HOUR_PX), 0)
}
